import React, { useState } from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import BASE_URL from "./apibaseurl/ApiBaseUrl";
import { Eye, EyeOff } from "lucide-react";


export default function Signup() {

    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        name: "",
        surname: "",
        email: "",
        mobile: "",
        password: "",
        confirmPassword: "",
        termsAccepted: false,
    });
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);


    const [errors, setErrors] = useState<{ [key: string]: string }>({});

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value, type, checked } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: type === "checkbox" ? checked : value,
        }));
        setErrors((prev) => ({ ...prev, [name]: "" })); // Clear error
    };

    const validate = () => {
        const newErrors: { [key: string]: string } = {};
        if (!formData.name) newErrors.name = "Name is required";
        if (!formData.surname) newErrors.surname = "Surname is required";
        if (!formData.email) newErrors.email = "Email is required";
        if (!formData.mobile) newErrors.mobile = "Mobile is required";
        if (!formData.password) newErrors.password = "Password is required";
        if (!formData.confirmPassword) newErrors.confirmPassword = "Confirm Password is required";
        if (formData.password && formData.password !== formData.confirmPassword) {
            newErrors.confirmPassword = "Passwords do not match";
        }
        if (!formData.termsAccepted) {
            newErrors.termsAccepted = "You must accept Terms & Policy";
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async () => {
        if (!validate()) return;

        const form = new FormData();
        form.append("user_fullname", formData.name);
        form.append("user_last_name", formData.surname);
        form.append("user_email", formData.email);
        form.append("user_mobile", formData.mobile);
        form.append("user_password", formData.password);

        try {
            const response = await fetch(`${BASE_URL}/register`, {
                method: "POST",
                body: form,
            });

            const data = await response.json();

            if (data?.status === 1) {
                toast.success( data.message || "Account created successfully!");
                localStorage.setItem("userData", JSON.stringify(data?.data));
                navigate("/login")
            } else {
                toast.error(data.message || "Registration failed");
            }
        } catch (error) {
            toast.error("Something went wrong");
        }
    };

    return (
        <div className="h-screen:h-[calc(100vh-79px)] flex flex-col bg-white mb-30 ">

            {/* Centered Content */}
            <div className="flex-grow flex items-center">

                <div className="lg:mx-20 mx-3 grid grid-cols-1 md:grid-cols-2 items-center px-4 py-16 gap-5 w-full">
                    {/* Left Form Section */}
                    <div className="space-y-6 lg:mx-[70px]">
                        <h2 className="text-[40px] lg:text-5xl  text-[#234042] Bebas-neue">
                            CREATE AN ACCOUNT
                        </h2>
                        <p className="text-lg lg:text-lg  text-[#F47321] ml-0 uppercase Bebas-neue tracking-light">ENTER YOUR ACCOUNT DETAILS</p>
                        <div className="grid grid-cols-2 sm:grid-cols-2 gap-2">
                            <div>
                                <label htmlFor="name" className="text-sm block mb-1 helvetica-neue  text-[#666666]">
                                    Name
                                </label>
                                <input
                                    id="name"
                                      name="name"  
                                    type="text"
                                    value={formData.name}
                                    onChange={handleChange}
                                    className="rounded-none  py-2 px-3 w-full bg-white  border border-[#666666] helvetica-neue !text-sm text-black"
                                />
                                {errors.name && <p className="text-red-500 !text-xs mt-1 helvetica-neue">{errors.name}</p>}

                            </div>
                            <div>
                                <label htmlFor="surname" className="text-sm block mb-1 helvetica-neue  text-[#666666]">
                                    Surname
                                </label>
                                <input
                                    id="surname"
                                    name="surname"
                                    type="text"
                                    value={formData.surname}
                                    onChange={handleChange}

                                    className="rounded-none bg-white  border border-[#666666] py-2 px-3 w-full helvetica-neue !text-sm text-black"
                                />
                                {errors.surname && <p className="text-red-500 !text-xs mt-1 helvetica-neue">{errors.surname}</p>}
                            </div>

                        </div>

                        <div className="grid grid-cols-2 sm:grid-cols-2 gap-2">
                            <div>
                                <label htmlFor="email" className="text-sm block mb-1 helvetica-neue  text-[#666666]">
                                    Email Address
                                </label>
                                <input
                                    id="email"
                                     name="email"
                                    type="email"
                                    value={formData.email}
                                    onChange={handleChange}

                                    className="rounded-none bg-white  border border-[#666666] py-2 px-3 w-full helvetica-neue !text-sm text-black"
                                />
                                {errors.email && <p className="text-red-500 !text-xs mt-1 helvetica-neue">{errors.email}</p>}
                            </div>
                            <div>
                                <label htmlFor="mobile" className="text-sm block mb-1 helvetica-neue  text-[#666666]">
                                    Mobile
                                </label>
                                <input
                                    id="mobile"
                                      name="mobile"
                                    type="text"
                                    value={formData.mobile}
                                    onChange={handleChange}
                                    className="rounded-none bg-white  border border-[#666666] py-2 px-3 w-full helvetica-neue !text-sm text-black"
                                />
                                {errors.mobile && <p className="text-red-500 !text-xs mt-1 helvetica-neue">{errors.mobile}</p>}
                            </div>
                        </div>

                        <div className="grid grid-cols-2 sm:grid-cols-2 gap-2">
                            <div> <label
                                htmlFor="password"
                                className="text-sm block mb-1 helvetica-neue text-[#666666]"
                            >
                                Password
                            </label>
                                <div className="relative">
                                    <input
                                        id="password"
                                        
                                        name="password"
                                        type={showPassword ? "text" : "password"}
                                        value={formData.password}
                                        onChange={handleChange}
                                        className="rounded-none bg-white border border-[#666666] py-2 px-3 w-full helvetica-neue !text-sm text-black pr-10"
                                    />
                                    <span
                                        className="absolute top-2.5 right-3 cursor-pointer text-gray-600"
                                        onClick={() => setShowPassword(!showPassword)}
                                    >
                                        {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                                    </span>
                                </div>
                                {errors.password && (
                                    <p className="text-red-500 !text-xs mt-1 helvetica-neue">{errors.password}</p>
                                )}</div>
                            <div>                           <label
                                htmlFor="confirmPassword"
                                className="text-sm block mb-1 helvetica-neue text-[#666666]"
                            >
                                Confirm Password
                            </label>
                                <div className="relative">
                                    <input
                                        id="confirmPassword"
                                        name="confirmPassword"
                                        type={showConfirmPassword ? "text" : "password"}
                                        value={formData.confirmPassword}
                                        onChange={handleChange}
                                        className="rounded-none bg-white border border-[#666666] py-2 px-3 w-full helvetica-neue !text-sm text-black pr-10"
                                    />
                                    <span
                                        className="absolute top-2.5 right-3 cursor-pointer text-gray-600"
                                        onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                    >
                                        {showConfirmPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                                    </span>
                                </div>
                                {errors.confirmPassword && (
                                    <p className="text-red-500 !text-xs mt-1 helvetica-neue">{errors.confirmPassword}</p>
                                )}</div>





                        </div>

                      <div className="flex items-center space-x-2">
  <input
    type="checkbox"
    id="terms"
    name="termsAccepted"
    checked={formData.termsAccepted}
    onChange={handleChange}
    className={errors.termsAccepted ? "ring-2 ring-red-500" : ""}
  />
  <label htmlFor="terms" className="!text-sm lg:!text-lg text-black helvetica-neue">
    I agree all statements in{" "}
    <span className="text-[#156E77]">Privacy & Policy</span> &{" "}
    <span className="text-[#156E77]">Terms & Conditions</span>
  </label>
</div>
{errors.termsAccepted && (
  <p className="text-red-500 !text-xs mt-1 helvetica-neue">{errors.termsAccepted}</p>
)}

                        <button
                            className="
        bg-[#F47321] 
        uppercase 
        hover:bg-[#F47321] 
        text-white 
        rounded-none 
         transition transform scale-y-125 text-xs lg:text-[15px] font-normal lg:px-4 lg:py-3 px-2 py-2 
        flex items-center gap-2 btn-hover-effect
    "
    onClick={handleSubmit}
                        >

                            <span>SUBMIT</span>
                            <span className="icon-arrow-right">
                                <ArrowRight className="w-3 h-3 sm:w-4 sm:h-4" />

                            </span>
                        </button>

                    </div>

                    {/* Right Image Section */}
                    <div className="block">
                        <img
                            src="/images/signup.png"
                            alt="signup illustration"
                            className="w-full "
                        />
                    </div>
                </div>
            </div>

            {/* Bottom Sign In - stays at bottom */}
            <div className="bg-[#156E77] text-white text-center py-4">
                <div className="lg:mx-[160px] mx-4 spx-4 flex flex-row  justify-between items-center">
                    <p className="!text-lg lg:!text-lg mb-0 lg:mb-2 !font-normal helvetica-neue">
                        Already have an account?
                    </p>
                    <Link to="/login">
                        <button
                            className="
        bg-white text-black rounded-none 
        transition transform scale-y-125 text-xs lg:text-[15px] font-normal lg:px-4 lg:py-3 px-2 py-2 
        uppercase 
        flex items-center gap-2 btn-hover-white
    "
                        >
                            <span>      SIGN IN INSTEAD</span>
                            <span className="icon-arrow-right">
                                <ArrowRight className="w-4 h-4 sm:w-5 sm:h-5" />

                            </span>

                        </button>
                    </Link>
                </div>
            </div>

        </div>
    );
}


